import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type AdvisoryTab = 'wq' | 'cso';

@Injectable({ providedIn: 'root' })
export class AdvisoryTabService {
  readonly activeTab$ = new BehaviorSubject<AdvisoryTab>('wq');

  setTab(tab: AdvisoryTab): void {
    this.activeTab$.next(tab);
  }
}
